import { InstitutionCheckExceptionReturnReasonDto } from '@treasury/api/channel';
import { ReturnReasonsDescriptions } from '../channel/types';
import { DomainEntity } from '../shared';

export class InstitutionCheckExceptionReturnReason extends DomainEntity<InstitutionCheckExceptionReturnReasonDto> {
    public createDefault(): this {
        return new InstitutionCheckExceptionReturnReason({
            description: '',
            returnReasonUniqueId: '',
            isDefault: false,
            isDeleted: false,
        }) as this;
    }

    public get description() {
        return (
            (this.dto.description as ReturnReasonsDescriptions) ?? ReturnReasonsDescriptions.None
        );
    }

    public get returnReasonUniqueId() {
        return this.dto.returnReasonUniqueId;
    }

    public get isDefault() {
        return this.dto.isDefault;
    }

    public get isDeleted() {
        return this.dto.isDeleted;
    }
}
